import React from 'react';
import { CheckIcon } from 'lucide-react';
import { sectionIcons } from './sectionIcons';
import { getOverallProgress, getSectionProgress } from '../../../utils/staffFormCompletion';

// Matches the reference design's SectionNav.tsx 1:1: overall percent + progress bar at the
// top, then a numbered/checked list of sections with a jump-to-section click handler.
const SectionNav = ({ sections, values, activeId, onSelect }) => {
    const overall = getOverallProgress(sections, values);
    const percent = overall.required === 0 ? 0 : Math.round((overall.completed / overall.required) * 100);

    return (
        <nav aria-label="Application sections" className="lg:tw-sticky lg:tw-top-32">
            <div className="tw-rounded-2xl tw-border tw-border-sand-200 tw-bg-white tw-p-4 tw-shadow-sm">
                <p className="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-gray-400">Your progress</p>
                <div className="tw-mt-2 tw-flex tw-items-baseline tw-gap-1.5">
                    <span className="tw-text-2xl tw-font-bold tw-text-brand-700">{percent}%</span>
                    <span className="tw-text-xs tw-text-gray-500">{overall.completed} of {overall.required} required fields</span>
                </div>
                <div className="tw-mt-3 tw-h-1.5 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-sand-200">
                    <div className="tw-h-full tw-rounded-full tw-bg-brand-600 tw-transition-all" style={{ width: `${percent}%` }} />
                </div>

                <ul className="tw-mt-4 tw-space-y-0.5">
                    {sections.map((section, index) => {
                        const Icon = sectionIcons[section.icon];
                        const progress = getSectionProgress(section, values);
                        const active = section.sectionKey === activeId;
                        return (
                            <li key={section.sectionKey}>
                                <button
                                    type="button"
                                    onClick={() => onSelect(section.sectionKey)}
                                    aria-current={active ? 'true' : undefined}
                                    className={`tw-flex tw-w-full tw-items-center tw-gap-2.5 tw-rounded-lg tw-px-2.5 tw-py-2 tw-text-left tw-text-sm tw-transition ${active ? 'tw-bg-brand-50 tw-font-semibold tw-text-brand-800' : 'tw-text-gray-600 hover:tw-bg-sand-100'}`}>
                                    <span className={`tw-flex tw-h-6 tw-w-6 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-text-[11px] tw-font-bold ${progress.isComplete ? 'tw-bg-brand-600 tw-text-white' : active ? 'tw-bg-white tw-text-brand-700' : 'tw-bg-sand-100 tw-text-gray-500'}`}>
                                        {progress.isComplete ? <CheckIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" /> : index + 1}
                                    </span>
                                    <span className="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-2">
                                        {Icon ? <Icon className="tw-hidden tw-h-4 tw-w-4 tw-shrink-0 tw-text-gray-400 sm:tw-block" aria-hidden="true" /> : null}
                                        <span className="tw-truncate">{section.title}</span>
                                    </span>
                                    {progress.required > 0 && !progress.isComplete ? (
                                        <span className="tw-shrink-0 tw-text-[11px] tw-text-gray-400">{progress.completed}/{progress.required}</span>
                                    ) : null}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </nav>
    );
};

export default SectionNav;
